import React from 'react';
import { Clock, Loader2, Send, CheckCheck, AlertTriangle, XCircle, Ban, Hand, HelpCircle } from 'lucide-react';
import { cn } from '@/lib/utils';
import { REPLY_STATUS } from '../../lib/chatsView';

/*
 * r16p (design 7.1): one chip per reply state - queued, picked up, sending, waiting for you (HELD), sent, not confirmed, not sent,
 * cancelled, and 'other' for a state this bundle does not know (inert: no action). The words are the page's; the state is the server's.
 */
export const TONE_CHIP = {
  primary: 'border-primary/30 bg-primary/10 text-primary',
  info: 'border-info/30 bg-info/10 text-info',
  success: 'border-success/30 bg-success/10 text-success',
  warning: 'border-warning/35 bg-warning/10 text-warning',
  danger: 'border-danger/30 bg-danger/10 text-danger',
  muted: 'border-border bg-muted/40 text-muted-foreground',
};

const ICONS = {
  queued: Clock, claimed: Clock, sending: Loader2, held: Hand, sent: CheckCheck, unconfirmed: AlertTriangle, failed: XCircle, cancelled: Ban,
  other: HelpCircle,
};

export default function ReplyStatusChip({ status, className, compact = false, testid }) {
  const meta = REPLY_STATUS[status];
  if (!meta) return null;
  const Icon = ICONS[status] || Send;
  return (
    <span
      className={cn('inline-flex shrink-0 items-center gap-1 rounded-full border font-medium leading-none',
        compact ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-1 text-[11px]', TONE_CHIP[meta.tone], className)}
      title={meta.hint}
      data-testid={testid}
      data-status={status}
    >
      <Icon className={cn(compact ? 'h-3 w-3' : 'h-3.5 w-3.5', status === 'sending' && 'animate-spin')} aria-hidden />
      {meta.label}
    </span>
  );
}
